import { useState, useCallback } from "react";
import { useDeepLink, DeepLink } from "./useDeepLink";

const useShare = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  const { createDeepLink, isLoading: deepLinkLoading, isError: deepLinkError } = useDeepLink();

  const loading = useCallback(() => {
    setIsLoading(true);
    setLink("");
    setError("");
  }, []);

  const success = useCallback((data: string) => {
    setIsLoading(false);
    setLink(data);
    // Log removido para reducir ruido en consola
  }, []);

  const failed = useCallback((data: string) => {
    setIsLoading(false);
    setError(data);
  }, []);

  const loadDeepLink = useCallback(async (
    linkableType: string,
    linkableId: string,
    targetUrl: string,
    title: string,
    description?: string,
    imageUrl?: string,
  ): Promise<string | null> => {
    if (!linkableType || !linkableId) {
      console.error('No se proporcionaron linkableType o linkableId');
      failed('Error al procesar el elemento');
      return null;
    }

    loading();

    try {
      const deepLink = await createDeepLink({
        targetUrl,
        title,
        description,
        imageUrl,
        linkableType,
        linkableId,
      });

      if (deepLink) {
        const linkToUse = deepLink.deepLinkUrl || deepLink.targetUrl || "";

        success(linkToUse);
        return linkToUse;
      } else {
        console.error("Failed to create/retrieve deep link for", linkableType, linkableId);
        failed("No se pudo crear el enlace de compartir");
        return null;
      }
    } catch (err) {
      console.error("Error creating/retrieving deep link:", err);
      failed("Error al crear el enlace de compartir");
      return null;
    }
  }, [loading, success, failed, createDeepLink]);

  return {
    isLoading: isLoading || deepLinkLoading,
    link,
    error: error || (deepLinkError ? "Error al crear el enlace de compartir" : ""),
    loading,
    success,
    failed,
    loadDeepLink,
  };
}

export default useShare;